import styled from "styled-components";

interface HeadCellProps {
  width?: string;
  negativeMargin?: string;
}
export const HeadCell = styled.th<HeadCellProps>`
  width: ${({ width }) => width ?? "auto"};
  block-size: fit-content;
  padding: 0.5rem;
  text-align: left;
  background-color: #024872;
  color: #fff;
  font-weight: 400;
  margin-left: ${({ negativeMargin }) => negativeMargin ?? "0"};
`;

export const Label = styled.label`
  display: flex;
  align-items: center;
  justify-content: start;
  gap: 0.25rem;
`;
